// @ts-strict-ignore
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { Language } from '../../../../model/enums/language';
import { UI_STRINGS } from '../../../../functions/language/uistrings';
import { ImageUrl } from '../../../shared-editor/components/image-list/image-list.component';

@Component({
    selector: 'app-gallery',
    templateUrl: './gallery.component.html',
    styleUrls: ['./gallery.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class GalleryComponent implements OnChanges, AfterViewInit, OnDestroy {
  @Input() images: ImageUrl[] = [];
  @Input() language: Language;

  @ViewChild('imageContainer') imageContainer: ElementRef;
  @ViewChild('thumbContainer') thumbContainer: ElementRef;
  @HostListener('window:resize', ['$event.target.innerWidth']) onResize(width: number) {
    this.init();
  }

  activeIndex: number = 0;
  focusedIndex: number = 0;
  height: string = '0px';
  imagePosition: string;
  width: string = '0px';

  private _imageElements: NodeListOf<HTMLImageElement>;
  private subscription: Subscription | undefined;
  private _width: number;

  readonly STRINGS = UI_STRINGS.GALLERY;

  get activeItem(): any {
    return this.images.length > this.activeIndex ? this.images[this.activeIndex] : undefined;
  }

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.images && !changes.images.firstChange) {
      this.activeIndex = 0;
      this.focusedIndex = 0;
      setTimeout(() => this.init());
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.init());
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  focusNext() {
    this.focusedIndex++;
    if (this.focusedIndex > this.images.length - 1) {
      this.focusedIndex = 0;
    }
    this._imageElements[this.focusedIndex].focus();
  }

  focusPrevious() {
    this.focusedIndex--;
    if (this.focusedIndex < 0) {
      this.focusedIndex = this.images.length - 1;
    }
    this._imageElements[this.focusedIndex].focus();
  }

  init() {
    this._imageElements = this.thumbContainer.nativeElement.querySelectorAll('img');
    this._width = this.imageContainer.nativeElement.offsetWidth as number;
    this.width = `${this._width}px`;
    this.height = `${this.imageContainer.nativeElement.offsetHeight as number}px`;
    this.cdr.detectChanges();
    this.setPositions();
    this.thumbContainer.nativeElement.addEventListener('focus', () => {
      this._imageElements[this.activeIndex].focus();
    });
  }

  next() {
    this.activeIndex++;
    if (this.activeIndex > this.images.length - 1) {
      this.activeIndex = 0;
    }
    this.focusedIndex = this.activeIndex;
    this.setPositions();
  }

  onThumbnailFocus(index: number) {
    this.focusedIndex = index;
  }

  previous() {
    this.activeIndex--;
    if (this.activeIndex < 0) {
      this.activeIndex = this.images.length - 1;
    }
    this.focusedIndex = this.activeIndex;
    this.setPositions();
  }

  selectImage(index: number) {
    this.activeIndex = index;
    this.focusedIndex = index;
    this.setPositions();
  }

  setPositions() {
    this.imagePosition = `${-this.activeIndex * this._width}px`;
    this.thumbContainer.nativeElement.scrollLeft = this.activeIndex * 56;
  }
}
